import React, { Fragment } from "react";

import FactItem from "./fact-item";
import { times, isEmpty } from "lodash";

const FactItemList = (props) => {
    const isCodingQA = props.isCodingQA;
    const gridTemplateColumns = isCodingQA ? `50px 156px repeat(${props.columnCount * 2}, 90px)` : `75px 176px repeat(${props.columnCount * 2}, 1fr)`;
    const width = {
        gridTemplateColumns: gridTemplateColumns,
    };

    const groupedFactItemMap = props.data
        .reduce((memo, d) => {
            memo.push(...d.facts);

            return memo;
        }, [])
        .reduce((map, item) => {
            const id = item.nutrient.value ? item.nutrient.value : item.nutrient.text;
            const facts = map.get(id) || [];
            facts.push(item);
            map.set(id, facts);

            return map;
        }, new Map());
    const groupedFactItems = Array.from(groupedFactItemMap, ([, value]) => value);

    const factHeaders = times(props.columnCount, (c) => {
        return (
            <Fragment key={`fact_item_header_${props.section}_${c}`}>
                <h3 style={{ minWidth: isCodingQA ? "25px" : "150px" }}>Value</h3>
                <h3 style={{ minWidth: isCodingQA ? "25px" : "150px" }}>% DV</h3>
            </Fragment>
        );
    });

    const factItems = groupedFactItems.map((item, i) => {
        const filterEmptyValues = item.filter((singleItem) => singleItem.quantity !== null || singleItem.pdv?.value !== null);
        const key = `fact_item_${props.section}_${i}of${groupedFactItems.length}`;

        return (
            <FactItem
                key={key}
                factId={key}
                data={item}
                noteMarkList={props.noteMarkList}
                showDescription={props.showDescription}
                columnStyle={width}
                hidden={isEmpty(filterEmptyValues)}
            />
        );
    });

    return (
        <div className="fact-items">
            <div
                className="fact-item"
                style={width}
            >
                <h3>Note</h3>
                <h3>Item</h3>
                {factHeaders}
            </div>
            {factItems}
        </div>
    );
};

export default FactItemList;
